import { formatCurrency } from "../../utils/formatters"; // Asegúrate de que la ruta sea correcta

const unitStyle = {
  position: "absolute",
  right: "0.5%",
  top: "52%",
};

// Función auxiliar para manejar el cambio de inputs con formato de moneda/puntos
const handleNumericChange = (ev, formProps, fieldName, extraLogic = null) => {
  let val = ev.target.value.replaceAll(".", "");
  const numericValue = parseFloat(val);

  if (isNaN(numericValue)) {
    formProps.setFieldValue(fieldName, "");
  } else {
    formProps.setFieldValue(fieldName, numericValue);
    if (extraLogic) extraLogic(numericValue);
  }
};

export const getSurfaceInputs = (formProps, zone) => {
  const inputs = [
    {
      name: "buildSurface",
      label: "Construida",
      type: "text", // Cambiado a text para soportar puntos visuales
      placeholder: "Escribe aquí",
      value: formProps.values.buildSurface
        ? formatCurrency(formProps.values.buildSurface)
        : "",
      onChange: (ev) =>
        handleNumericChange(ev, formProps, "buildSurface", (newSurface) => {
          // SOLO recalculamos la repercusión de venta si hay un precio de venta definido
          if (formProps.values.saleValue && newSurface > 0) {
            formProps.setFieldValue(
              "saleRepercussionM2",
              Math.round(formProps.values.saleValue / newSurface),
            );
          }
        }),
      span: (
        <span style={unitStyle}>
          m<sup>2</sup>
        </span>
      ),
    },
    {
      name: "plotSurface",
      label: "Parcela",
      type: "text",
      placeholder: "Escribe aquí",
      value: formProps.values.plotSurface
        ? formatCurrency(formProps.values.plotSurface)
        : "",
      onChange: (ev) => handleNumericChange(ev, formProps, "plotSurface"),
      span: (
        <span style={unitStyle}>
          m<sup>2</sup>
        </span>
      ),
    },
  ];

  if (zone === "Costa") {
    inputs.push(
      {
        name: "m2Terrace",
        label: "Terraza",
        type: "text",
        placeholder: "Escribe aquí",
        value: formProps.values.m2Terrace
          ? formatCurrency(formProps.values.m2Terrace)
          : "",
        onChange: (ev) => handleNumericChange(ev, formProps, "m2Terrace"),
        span: (
          <span style={unitStyle}>
            m<sup>2</sup>
          </span>
        ),
      },
      {
        name: "m2StorageSpace",
        label: "Trastero",
        type: "text",
        placeholder: "Escribe aquí",
        value: formProps.values.m2StorageSpace
          ? formatCurrency(formProps.values.m2StorageSpace)
          : "",
        onChange: (ev) => handleNumericChange(ev, formProps, "m2StorageSpace"),
        span: (
          <span style={unitStyle}>
            m<sup>2</sup>
          </span>
        ),
      },
    );
  }
  return inputs;
};

export const getPriceInputs = (formProps) => {
  const { saleValue, buildSurface } = formProps.values;

  // Cálculos dinámicos para la visualización inmediata en el CRM
  const calcSaleRepercussion =
    saleValue && buildSurface && buildSurface > 0
      ? Math.round(saleValue / buildSurface)
      : "";

  return [
    // --- GRUPO VENTA ---
    {
      name: "saleValue",
      label: "Venta",
      type: "text",
      placeholder: "Escribe aquí",
      value: formProps.values.saleValue
        ? formatCurrency(formProps.values.saleValue)
        : "",
      onChange: (ev) =>
        handleNumericChange(ev, formProps, "saleValue", (newSaleValue) => {
          // ACTUALIZAR la repercusión cuando cambie el precio de venta
          if (
            formProps.values.buildSurface &&
            formProps.values.buildSurface > 0
          ) {
            formProps.setFieldValue(
              "saleRepercussionM2",
              Math.round(newSaleValue / formProps.values.buildSurface),
            );
          }
        }),
      span: <span style={unitStyle}>€</span>,
    },
    {
      name: "saleShowOnWeb",
      label: "Mostrar Web",
      type: "checkbox",
      checked: formProps.values.saleShowOnWeb,
      onChange: (ev) =>
        formProps.setFieldValue("saleShowOnWeb", ev.target.checked),
    },
    {
      name: "saleRepercussionM2",
      label: "Repercusión Venta",
      labelStyle: { marginTop: "1rem" },
      type: "text",
      placeholder: "Escribe aquí",
      disabled: true,
      readOnly: true,
      value:
        calcSaleRepercussion !== "" ? formatCurrency(calcSaleRepercussion) : "",
      span: (
        <span style={unitStyle}>
          €/m<sup>2</sup>
        </span>
      ),
    },
    {
      name: "saleRepercussionM2ShowOnWeb",
      label: "Mostrar Repercusión Web",
      type: "checkbox",
      checked: formProps.values.saleRepercussionM2ShowOnWeb,
      onChange: (ev) =>
        formProps.setFieldValue(
          "saleRepercussionM2ShowOnWeb",
          ev.target.checked,
        ),
    },

    {
      name: "rentValue",
      label: "Alquiler",
      type: "text",
      placeholder: "Escribe aquí",
      value: formProps.values.rentValue
        ? formatCurrency(Math.round(formProps.values.rentValue))
        : "",
      onChange: (ev) => handleNumericChange(ev, formProps, "rentValue"),
      span: <span style={unitStyle}>€/mes</span>,
    },
    {
      name: "rentShowOnWeb",
      label: "Mostrar Web",
      type: "checkbox",
      checked: formProps.values.rentShowOnWeb,
      onChange: (ev) =>
        formProps.setFieldValue("rentShowOnWeb", ev.target.checked),
    },
  ];
};
